import ServiceEndpoints from "../ServiceEndpoints";

export async function bulkUpload(file: File, userToken?: string,profileName?: string) {
    const data = new FormData();
    data.append('file', file);
    data.append('UserDisplayName', profileName || '');

    return await fetch(`${ServiceEndpoints.BulkUpload}`, {
        method: 'post',
        headers: { // Explicitly set the Content-Type
            "Authorization": "Bearer " + userToken },
        body: data
    }).then(async (resp) => {
        if (resp.ok) {
            return;
        }
        const errorData = await resp.text();
        throw new Error(errorData ?? 'Some error occurred.');
    }).catch((error) => {
        console.error(error.message);
        throw new Error(error.message);
    });
}

export async function bulkUploadHist(file: File, userToken?: string, profileName?: string) {
    const data = new FormData();
    data.append('file', file);
    data.append('userDisplayName', profileName || '');
    return await fetch(`${ServiceEndpoints.BulkUploadHist}`, {
        method: 'post',
        headers: { "Authorization": "Bearer " + userToken },
        body: data
    }).then(async (resp) => {
        if (resp.ok) {
            return;
        }
        const errorData = await resp.text();
        throw new Error(errorData ?? 'Some error occurred.');
    }).catch((error) => {
        console.error(error.message);
        throw new Error(error.message);
    });
}